<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="birthday-for-a-friend">
<h1>Birthday for a Friend</h1>
<p style="text-indent:0px;">It appears something strange,</p>
<p style="text-indent:0px;">Is happening soon!</p>
<p style="text-indent:0px;">It’s not the wind may change,</p>
<p style="text-indent:0px;">Nor does it involve the moon!</p><br/>
<p style="text-indent:0px;">It is not to be feared,</p>
<p style="text-indent:0px;">This coming occasion.</p>
<p style="text-indent:0px;">Not the first time it’s appeared,</p>
<p style="text-indent:0px;">And snuck up like an assassin.</p><br/>
<p style="text-indent:0px;">Actually, it is a liar,</p>
<p style="text-indent:0px;">This that shall appear.</p>
<p style="text-indent:0px;">For you look much younger,</p>
<p style="text-indent:0px;">Your youthfulness it does fear.</p><br/>
<p style="text-indent:0px;">We’ve have been through a lot,</p>
<p style="text-indent:0px;">I’m surprised we’re still alive.</p>
<p style="text-indent:0px;">Always, your back I’ve got,</p>
<p style="text-indent:0px;">With pride I watch you thrive.</p><br/>
<p style="text-indent:0px;">Hidden in the clues,</p>
<p style="text-indent:0px;">Are answers to what’s coming.</p>
<p style="text-indent:0px;">A day for rhythm and blues,</p>
<p style="text-indent:0px;">A day for celebrating.</p><br/>
<p style="text-indent:0px;">Of course it’s your birthday,</p>
<p style="text-indent:0px;">You made another year.</p>
<p style="text-indent:0px;">Forever you will my sister stay,</p>
<p style="text-indent:0px;">With lots of laughs and tears.</p><br/>
<p style="text-indent:0px;">A lot has happened,</p>
<p style="text-indent:0px;">For you and I to be here.</p>
<p style="text-indent:0px;">Our lives were truly threatened,</p>
<p style="text-indent:0px;">But away from it we did steer.</p><br/>
<p style="text-indent:0px;">Onwards and upwards now,</p>
<p style="text-indent:0px;">A new beginning starts.</p>
<p style="text-indent:0px;">Be proud, take a bow,</p>
<p style="text-indent:0px;">You have a golden heart.</p><br/>
<p style="text-indent:0px;">Happy birthday, my cousin,</p>
<p style="text-indent:0px;">Have a day filled with sun.</p>
<p style="text-indent:0px;">If I had to choose from a dozen,</p>
<p style="text-indent:0px;">You’d be my chosen one.</p><br/>
<p style="text-indent:0px;">Go put on your dancing shoes,</p>
<p style="text-indent:0px;">I’ll watch you from above.</p>
<p style="text-indent:0px;">You can drink all the booze,</p>
<p style="text-indent:0px;">I’ll get you home with love.</p>
<p style="text-indent:0px;"><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch016.vue?3d8ef5ca